import { useSelector } from 'react-redux';
import { Box, Text } from '@rsos/base-components';
import { useFlag } from '@rsos/flags';
import useHasAccessToSummarizationAndKeywords from '../../../../../hooks/useHasAccessToSummarizationAndKeywords';
import useHasAccessToTranscriptAndAudioPlayback from '../../../../../hooks/useHasAccessToTranscriptAndAudioPlayback';
import AudioPlayer from '../../AudioPlayer';
import CollaboratorBanner from '../CollaboratorBanner';
import IncidentSummary from './IncidentSummary';
import { TranscriptFeedback } from './TranscriptFeedback';
import TranscriptViewer from './TranscriptViewer';
import { TranscriptContent } from './TranscriptionTab.styles';

/**
 * The Transcript tab of the EventPane
 */
const TranscriptionTab = ({ callerId }) => {
  const isInternalFeedbackEnabled = useFlag('transcript_feedback_api');
  const hasAccessToTranscriptionAndAudioPlayback =
    useHasAccessToTranscriptAndAudioPlayback();
  const hasAccessToSummarizationAndKeywords =
    useHasAccessToSummarizationAndKeywords();
  const hasData =
    hasAccessToTranscriptionAndAudioPlayback ||
    hasAccessToSummarizationAndKeywords;

  const isTranscriptMaximized = useSelector(
    state => state?.transcriptions?.maximized,
  );

  const shouldRenderSummary =
    !isTranscriptMaximized && hasAccessToSummarizationAndKeywords;

  return (
    <Box gridRowGap="16px" height="100%">
      <CollaboratorBanner />
      {((shouldRenderSummary && callerId) || isInternalFeedbackEnabled) && (
        <TranscriptFeedback callerId={callerId} />
      )}
      {hasAccessToTranscriptionAndAudioPlayback && (
        <AudioPlayer callerId={callerId} />
      )}
      {shouldRenderSummary && <IncidentSummary callerId={callerId} />}

      <TranscriptContent>
        {hasData ? (
          <>
            {hasAccessToTranscriptionAndAudioPlayback && (
              <TranscriptViewer
                isTranscriptMaximized={isTranscriptMaximized}
                callerId={callerId}
              />
            )}
          </>
        ) : (
          <Text textAlign="center" color="secondaryText">
            No Audio or Transcript available
          </Text>
        )}
      </TranscriptContent>
    </Box>
  );
};

export default TranscriptionTab;
